import { ApiDataResponse, ApiDatum } from '@api/v4/ApiResponseTypes';

export enum ServerUserRoles {
  Admin = 'admin',
  Collaborator = 'collaborator',
  Guest = 'guest',
  Owner = 'owner'
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IncludedUserPermission {
  key: string;
  permission_level: ServerUserRoles;
  insights_url: string;
}

export interface DetailedUser {
  email: string;
  resource_user_permission: ApiDatum<IncludedUserPermission, 'user_permission'>;
  company?: string;
  country?: string;
  created_with_saml?: boolean;
  created_with_sso?: boolean;
  department?: string;
  first_name?: string;
  full_name?: string;
  last_active_at?: string;
  last_name?: string;
  locale?: string;
  superuser?: boolean;
  title?: string;
}

export type IndexDetailedUsersResponse = ApiDataResponse<DetailedUser, 'users'>;